export { default } from './useAutoEntitlementSwitcher';
export * from './useAutoEntitlementSwitcher';
